export enum FccConfigType {
	TEXT = 'text',
	STAGE = 'stage',
	CALC = 'calc',
}